// extracted by mini-css-extract-plugin
export default {"wrapperDataNotFound":"DataNotFound_wrapperDataNotFound__civiR","column":"DataNotFound_column__sbseA"};